import React from "react";

interface RegisterStepSummaryMobileProps {
  currentIndex: number;
  totalSteps: number;
}

export const RegisterStepSummaryMobile: React.FC<
  RegisterStepSummaryMobileProps
> = ({ currentIndex, totalSteps }) => {
  return (
    <div className="border-b border-gray-100 px-4 py-2 text-xs text-gray-600 dark:border-gray-800 dark:text-gray-400 lg:hidden">
      Etapa {currentIndex} de {totalSteps}
    </div>
  );
};

export default RegisterStepSummaryMobile;

